import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ActivatedRoute, Router } from "@angular/router";
import {
  appVersionRestClientInjectionToken
} from "../../rest-clients/application-version/app-version/app-version-rest-client-injection-token";
import { ESeverity, IToastService, toastServiceInjectionToken } from '@zaeper/angular-dashboard-view-lib';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Button } from "primeng/button";
import { Editor } from "primeng/editor";
import { InputText } from "primeng/inputtext";
import { ICreateRecordResponse } from '@zaeper/communication-lib';
import { IAppVersionRestClient } from "../../rest-clients/application-version/app-version/i-app-version-rest.client";
import { ICreateAppVersionModalOptions } from "./i-create-app-version-modal.options";

@Component( {
  templateUrl: 'create-app-version-modal.component.html',
  imports: [
    Editor, ReactiveFormsModule, Button, InputText
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class CreateAppVersionModalComponent {
  protected readonly appVersionForm: FormGroup;

  constructor(
    @Inject( appVersionRestClientInjectionToken ) private readonly _appVersionRestClient: IAppVersionRestClient,
    @Inject( toastServiceInjectionToken ) private readonly _toastService: IToastService,
    private readonly _formBuilder: FormBuilder,
    private readonly _dynamicDialogRef: DynamicDialogRef,
    private _dynamicDialogConfig: DynamicDialogConfig<ICreateAppVersionModalOptions>,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router
  ) {
    this.appVersionForm = this._formBuilder.group( {
      changelog: new FormControl( "" )
    } );
  }

  protected async submit(event: SubmitEvent): Promise<void> {
    try {
      const appId: string = this._dynamicDialogConfig.data!.appId;
      const createAppVersionResponse: ICreateRecordResponse = await this._appVersionRestClient.createAppVersion( appId, this.appVersionForm.value );

      this._toastService.setMessage( {
        title: 'Erfolgreich',
        detail: 'App Version wurde erfolgreich erstellt.',
        severity: ESeverity.success
      } );

      this.close();

      await this._router.navigate( [
        "app-version", createAppVersionResponse.recordId
      ], { relativeTo: this._activatedRoute } );
    } catch ( e ) {
      this._toastService.setMessage( {
        title: 'Fehlgeschlagen',
        detail: 'App Version konnte nicht erstellt werden.',
        severity: ESeverity.error
      } );
    }
  }

  protected close(): void {
    this._dynamicDialogRef.close();
  }
}
